import React, { useState } from 'react';
import { Button } from '../../../components/ui/button';
import { Label } from '../../../components/ui/label';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '../../../components/ui/select';
import { RichTextEditor } from '../../../components/RichTextEditor';
import { ForumCategoria, ForumCategoriaLabels, CreateForumPostData, ForumPost, UpdateForumPostData } from '../../../types/forum';

interface ForumPostFormProps {
  initialData?: ForumPost;
  onSubmit: (data: CreateForumPostData | UpdateForumPostData) => Promise<void>;
  onCancel: () => void;
  isLoading?: boolean;
}

export function ForumPostForm({ initialData, onSubmit, onCancel, isLoading }: ForumPostFormProps) {
  const [conteudo, setConteudo] = useState(initialData?.conteudo || '');
  const [categoria, setCategoria] = useState<ForumCategoria>(initialData?.categoria || ForumCategoria.GERAL);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!conteudo.trim()) {
      return;
    }

    await onSubmit({
      conteudo,
      categoria,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="categoria">Categoria</Label>
        <Select value={categoria} onValueChange={(value) => setCategoria(value as ForumCategoria)} disabled={isLoading}>
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {Object.values(ForumCategoria).map((cat) => (
              <SelectItem key={cat} value={cat}>
                {ForumCategoriaLabels[cat]}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label>Conteúdo</Label>
        <RichTextEditor
          value={conteudo}
          onChange={setConteudo}
          placeholder="Digite o conteúdo do post..."
          height="250px"
        />
      </div>

      <div className="flex justify-end gap-2 pt-4">
        <Button type="button" variant="outline" onClick={onCancel} disabled={isLoading}>
          Cancelar
        </Button>
        <Button type="submit" disabled={isLoading || !conteudo.trim()}>
          {isLoading ? 'Salvando...' : initialData ? 'Salvar Alterações' : 'Criar Post'}
        </Button>
      </div>
    </form>
  );
}
